module.exports = __webpack_public_path__ + "assets/img/li_icon.2888c36d.svg";